var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4116 22.333C6.88877 22.333 2.41162 17.8558 2.41162 12.333C2.41162 6.81016 6.88877 2.33301 12.4116 2.33301C17.9344 2.33301 22.4116 6.81016 22.4116 12.333C22.4116 17.8558 17.9344 22.333 12.4116 22.333ZM12.4116 9.83301C13.24 9.83301 13.9116 9.16144 13.9116 8.33301C13.9116 7.50458 13.24 6.83301 12.4116 6.83301C11.5832 6.83301 10.9116 7.50458 10.9116 8.33301C10.9116 9.16144 11.5832 9.83301 12.4116 9.83301ZM14.4116 15.333H13.4116V10.833H10.4116V12.833H11.4116V15.333H10.4116V17.333H14.4116V15.333Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfoIcon);
export default __webpack_public_path__ + "static/media/error-info-icon.0c4a45f25cecfdfb3c8d775295c79b5b.svg";
export { ForwardRef as ReactComponent };